export const en = {
    entities: {
        alerts: {
            create: {
                title: "Create Entity",
                text: "Are you sure you want to create <b>%{entity}</b>",
                success: {
                    title: "Entity Created Successfully",
                    text: "<b>%{entity}</b> was created successfully",
                },
                error: {
                    title: "Entity Create Error",
                    text: "Something went wrong. Please try again later",
                }
            },
            delete: {
                title: "Delete Entity",
                text: "Are you sure you want to delete <b>%{entity}</b>",
                success: {
                    title: "Entity Deleted Successfully",
                    text: "You will now be redirected to the Entities page",
                },
                error: {
                    title: "Entity Delete Error",
                    text: "Something went wrong. Please try again later",
                }
            },
            edit: {
                title: "Edit Entity",
                text: "Are you sure you want to edit <b>%{entity}</b>",
                success: {
                    title: "Entity Edited Successfully",
                    text: "<b>%{entity}</b> was edited successfully",
                },
                error: {
                    title: "Entity Edit Error",
                    text: "Something went wrong. Please try again later",
                }
            }
        },
        types: {
            basic: "Basic",
            company: "Company",
            region: "Region",
            building: "Building",
            floor: "Floor",
            meetingRoom: "Meeting Room",
            openSpace: "Open Space",
        },
        list: {
            name: "Name",
            parent: "Parent Entity",
            type: "Type"
        },
        form: {
            headers: {
                create: "Create Entity",
                edit: "Edit Entity",
                view: "View Entity",
                entityInterfaces: "Associated Interfaces"
            },
            name: {
                label: "Name",
            },
            type: {
                label: "Type",
            },
            parent: {
                label: "Parent",
            },
            email: {
                label: "Email",
            },
            entity: {
                label: "Entity",
            },
            status: {
                label: "Status",
                enabled: "Enabled",
                disabled: "Disabled",
            },
            language: {
                label: "Language",
            },
            timezone: {
                label: "Timezone",
            },
        },
        errors: {
            invalidEmail: "Invalid email format",
            invalidCapacity: "Invalid capacity format",
            invalidUrl: "Invalid URL format",
            area: "Invalid area format",
            image: "Invalid image format",
            tolerance: "Invalid tolerance format",
            calendarDepth: "Invalid weeks format",
            checkInOpen: "Invalid check-in open time format",
            invalidLatitude: "Invalid latitude format",
            invalidLongitude: "Invalid longitude format",
            maxMeetingTime: "Invalid maximum meeting time format",
            minMeetingTime: "Invalid minimum meeting time format",
            minimumSchedulingPeriod: "Invalid minimum scheduling period format",
            quickBookPeriod: "Invalid quick book period format",
            operationTimeStartBeforeEnd: "Open time should be before close time",
            operationTimeEndAfterStart: "Close time should be after open time",
            autoCheckOutDelay: "Invalid integer value"
        },
        permissions: {
            ENTITIES: "Entities",
            CREATE_ENTITY: "Create entities",
            READ_ENTITY: "Read entities",
            UPDATE_ENTITY: "Update entities",
            DELETE_ENTITY:"Delete entities"
        }
    },
    entitiesInterfaces: {
        permissions: {
            ENTITIES_INTERFACES: "Entities Interfaces",
            CREATE_ENTITY_INTERFACE: "Create Entity Interface",
            EDIT_ENTITY_INTERFACE: "Edit Entity Interface",
            DELETE_ENTITY_INTERFACE: "Delete Entity Interface"
        }
    }
};